import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-softgrey-600">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
